module.exports = require("fbemitter");


//////////////////
// WEBPACK FOOTER
// external "fbemitter"
// module id = 17
// module chunks = 0